// Billing module (2026-10-25, billing MVP week) - SHADOW and DARK.
//
// The SERVER decides who sees billing: GET /api/billing/access answers 200
// {"enabled": true} only for a login with an active grant (billing.access_grants),
// and the same 404 as an unknown route for everyone else. The browser only
// mirrors that answer: anything but a clean 200 with enabled === true reads as
// "no billing" - the menu stays hidden and /billing goes home. A 404 never
// triggers the 401 sign-out in api/client.js.
//
// One check per signed-in page load, shared by the menu and the page.

let _cached = null; // { userKey, promise }

export function billingAllowed(res) {
  return !!(res && res.status === 200 && res.data && res.data.enabled === true);
}

export function fetchBillingAccess(api, userKey) {
  if (!api || !userKey) return Promise.resolve(false);
  if (_cached && _cached.userKey === userKey) return _cached.promise;
  const promise = api
    .get("/billing/access")
    .then((res) => billingAllowed(res))
    .catch(() => false);
  _cached = { userKey, promise };
  return promise;
}

export function resetBillingAccessCache() {
  _cached = null;
}
